// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Loader2 } from "lucide-react";

// Single shared bootstrap loader. Used by both App (auth/permissions/tenant
const LoadingScreen = ({
  title = "Getting things ready",
  message = "Loading your dashboard…",
  isDarkMode = false,
}) => (
  <div
    className={`min-h-screen flex items-center justify-center ${isDarkMode ? "bg-gray-900" : "bg-gradient-to-br from-blue-50 to-indigo-50"}`}
  >
    <div className="text-center px-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className={`w-20 h-20 border-4 rounded-full ${isDarkMode ? "border-blue-900" : "border-blue-100"}`}
          ></div>
        </div>
        <Loader2
          className={`relative h-20 w-20 animate-spin mx-auto ${isDarkMode ? "text-blue-400" : "text-blue-600"}`}
        />
      </div>
      <h2
        className={`text-2xl font-semibold mt-6 mb-2 ${isDarkMode ? "text-gray-100" : "text-gray-900"}`}
      >
        {title}
      </h2>
      <p
        className={`max-w-md mx-auto ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}
      >
        {message}
      </p>
      <div className="mt-4 flex justify-center space-x-1">
        <span
          className={`w-2 h-2 rounded-full animate-bounce ${isDarkMode ? "bg-blue-400" : "bg-blue-600"}`}
        ></span>
        <span
          className={`w-2 h-2 rounded-full animate-bounce ${isDarkMode ? "bg-blue-400" : "bg-blue-600"}`}
          style={{ animationDelay: "0.1s" }}
        ></span>
        <span
          className={`w-2 h-2 rounded-full animate-bounce ${isDarkMode ? "bg-blue-400" : "bg-blue-600"}`}
          style={{ animationDelay: "0.2s" }}
        ></span>
      </div>
    </div>
  </div>
);

export default LoadingScreen;
